import clsx from 'clsx';

import { Content } from '@/lib';
import styles from './Warning.module.scss';
import { Row } from '../../Row';

export function Warning({ title, message, fluid }: Content.WithFluid<Content.Warning>) {
  return (
    <Row className={clsx(fluid && styles.fluid)}>
      <div className={styles.warning}>
        <div className={clsx(styles.alarm, 'h1')}>!</div>
        <div className={styles.content}>
          <p className={clsx(styles.title, 'text text-bold')}>{title}</p>
          <p className={clsx(styles.message, 'text')}>{message}</p>
        </div>
      </div>
    </Row>
  );
}
